import { Formik } from "formik";
import { useEffect, useState, createRef } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Helmet from "react-helmet";

import { Page, PageHeader, Title } from "../../components/styles";
import GoBack from "../../../../components/GoBack";
import Link from "../../../../components/Link";
import Submit from "../../../../components/FormikForm/Submit";
import { Group, User } from "../../../../types";
import Grid from "../../../../components/Grid";
import {
  initialValues,
  schema,
} from "../../../../constants/forms/sessions/edit";
import {
  getOneSession,
  newSession,
  resetNewSession,
  resetUpdateOneSession,
  updateSession,
} from "../../../../store/actions/session";
import {
  dateSpliter,
  inputDate,
  inputDateTimeLocal,
  setToZeroTimeZone,
} from "../../../../helpers/dates-hanlder";
import SessionForm from "../components/SessionForm";
import moment from "moment";
import { getGroupById } from "../../../../store/actions/group";
import { SessionInDto } from "../../../../types/session.dto";
import Snackbar from "../../../../components/Snackbar";
import Loader from "../../../../components/LogoLoader";
import { useLayout } from "../../../../providers/LayoutProvider";
import { useFileUploadProgress } from "../../../../providers/FileUploader";
import { hideModal, showModal } from "../../../../store/actions/modal";
import ModalWaitAMinuteBis from "../../Posts/New/components/ModalWaitAMinute";

interface ComponentProps {
  groupInformation: Group;
  groupStates: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
  sessionInformation: SessionInDto;
  sessionStates: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
  sessionEditStates: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
  userInformation: any;
  match;
}

const Component = ({
  groupInformation,
  groupStates,
  sessionInformation,
  sessionStates,
  sessionEditStates,
  userInformation,
  match,
}: ComponentProps) => {
  const { layout, setLayout } = useLayout();
  const { uploadFiles, resetFileUploadProgress } = useFileUploadProgress();
  const dispatch = useDispatch();
  const history = useHistory();
  const [videoUploaded, setVideoUploaded] = useState(false);
  const [groupId, setGroupId] = useState<number>();
  const [formSubmmited, setFormSubmmited] = useState(false);


  const onSubmit = async ({ values, actions }) => {
    const { speaker_name, speaker_profile_pic, session_datetime,
      will_be_recorded, notificate_by_chat, notificate_by_email,
      recording_expiration_datetime, complementary_material_files, ...rest } = values;

    const useProfileInfo = values.use_profile_info.length > 0;

    // Detectar si se está subiendo una grabación por primera vez
    const isUploadingRecording = (
      !sessionInformation.recorded_session_url &&
      !!values.recorded_session_url &&
      values.recorded_session_url.trim() !== ""
    );

    setVideoUploaded(isUploadingRecording);

    // Verificar si hay archivos para subir
    const thereAreFilesToUpload = values && (
      // (values.cover_pic?.some(file => file instanceof File)) ||
      // (values.speaker_profile_pic?.some(file => file instanceof File)) ||
      (values.complementary_material_files?.some(file => file instanceof File))
    );

    if (thereAreFilesToUpload) {
      dispatch(showModal("modal-wait-a-minute-bis"));
    }

    try {
      const remindersSettings = values['session_reminders_settings'].map(remSett => {
        return { ...remSett, enabled: remSett?.enabled?.includes("true"), exec_datetime: remSett?.exec_datetime ? setToZeroTimeZone(remSett.exec_datetime) : remSett.exec_datetime }
      })

      const recordingExpirationDate = (!!recording_expiration_datetime && recording_expiration_datetime !== "")
        ? setToZeroTimeZone(recording_expiration_datetime)
        : null

      if (thereAreFilesToUpload) {
        // Subir archivos primero
        const uploadedFiles = await uploadFiles(
          {
            // ...(values?.cover_pic && values?.cover_pic.length > 0 && { cover_pic: values?.cover_pic }),
            // ...(values?.speaker_profile_pic && values?.speaker_profile_pic.length > 0 && { speaker_profile_pic: values?.speaker_profile_pic }),
            ...(values?.complementary_material_files && values?.complementary_material_files.length > 0 && { complementary_material_files: values?.complementary_material_files }),
          },
          userInformation.id,
          "session"
        );

        const obj = {
          ...rest,
          ...(!useProfileInfo && { speaker_name, speaker_profile_pic: uploadedFiles?.speaker_profile_pic || values.speaker_profile_pic }),
          recording_expiration_datetime: recordingExpirationDate,
          use_profile_info: useProfileInfo,
          session_dt_in_local_timezone: session_datetime,
          session_datetime: setToZeroTimeZone(session_datetime),
          will_be_recorded: will_be_recorded?.includes("true") || false,
          notificate_by_chat: notificate_by_chat?.includes("true") || false,
          notificate_by_email: notificate_by_email?.includes("true") || false,
          complementary_material_downloadable: values.complementary_material_downloadable?.includes("true") || false,
          cover_pic: uploadedFiles?.cover_pic || values.cover_pic,
          complementary_material_files: uploadedFiles?.complementary_material_files || values.complementary_material_files,
          session_reminders_settings: remindersSettings
        }

        dispatch(updateSession(obj));
      } else {
        // Si no hay archivos para subir, enviar directamente
        const obj = {
          ...rest,
          ...(!useProfileInfo && { speaker_name, speaker_profile_pic }),
          recording_expiration_datetime: recordingExpirationDate,
          use_profile_info: useProfileInfo,
          session_dt_in_local_timezone: session_datetime,
          session_datetime: setToZeroTimeZone(session_datetime),
          will_be_recorded: will_be_recorded?.includes("true") || false,
          notificate_by_chat: notificate_by_chat?.includes("true") || false,
          notificate_by_email: notificate_by_email?.includes("true") || false,
          complementary_material_downloadable: values.complementary_material_downloadable?.includes("true") || false,
          session_reminders_settings: remindersSettings
        }

        dispatch(updateSession(obj));
      }
    } catch (error) {
      console.error('Error during file uploads:', error);
    } finally {
      dispatch(hideModal());
    }
  };

  useEffect(() => {
    if (!!match?.params) {
      setGroupId(Number(match?.params?.idGroup));
    }
  }, [match]);

  useEffect(() => {
    if (!!groupId) {
      groupInformation?.id !== groupId &&
        dispatch(getGroupById({ group_id: groupId }));
      sessionInformation?.id !== Number(match?.params?.session) &&
        dispatch(getOneSession({ idSession: Number(match?.params?.session) }));
    }
  }, [groupId, groupInformation]);

  useEffect(() => {
    if (!!sessionInformation && sessionEditStates.success) {
      setTimeout(() => {
        const groupId = groupInformation?.id;
        const sessionId = sessionInformation?.id;
        dispatch(resetUpdateOneSession());
        resetFileUploadProgress();
        dispatch(hideModal());
        history.push(
          `/group/${groupId}/s/${sessionId}${videoUploaded ? "?video-uploaded=t" : ""
          }`
        );
      }, 3500);
    }
  }, [sessionInformation, sessionEditStates]);

  useEffect(() => {
    setLayout({
      ...layout,
      page: {
        title: "Editar encuentro",
        description: "Editar encuentro",
        back: `/dashboard/${groupInformation?.group_type}/${groupInformation?.id}/sessions`,
      },
      dashboard: {
        tabs: {
          visible: false,
        },
      },
      header: {
        visible: true,
        actions: [
          <Link
            style={{ marginRight: "8px" }}
            options={{
              type: "outline",
              size: "lg",
              skin: "purple",
              native: true,
            }}
            disabled={groupStates.loading}
            loading={groupStates.loading}
            href={`/dashboard/${groupInformation?.group_type}/${groupInformation?.id}/sessions`}
          >
            Cancelar
          </Link>,

          <Submit
            isSubmmiting={sessionEditStates.loading}
            options={{
              type: "filled",
              size: "lg",
              skin: "purple",
            }}
            form="edit-session-form"
          >
            Guardar
          </Submit>,
        ],
      },
    });
  }, [groupInformation, groupStates.loading, sessionEditStates.loading]);

  if (!sessionInformation) {
    return <Loader />;
  }

  return (
    <>
      <Grid.Container>
        <div style={{ height: "15px" }}></div>

        <Grid.Row>
          <Grid.Col lg={6}>
            <Formik
              initialValues={{
                ...initialValues,
                ...sessionInformation,
                ...(sessionInformation["cover_pic"] && {
                  cover_pic: [sessionInformation["cover_pic"]],
                }),
                ...(sessionInformation["speaker_profile_pic"] && {
                  speaker_profile_pic: [
                    sessionInformation["speaker_profile_pic"],
                  ],
                }),
                ...(sessionInformation["complementary_material_files"] && {
                  complementary_material_files: sessionInformation["complementary_material_files"],
                }),
                content_categories: sessionInformation.content_categories.map(
                  (category) => category.id
                ),
                use_profile_info: sessionInformation.use_profile_info
                  ? ["true"]
                  : [],
                notificate_by_chat: sessionInformation.notificate_by_chat
                  ? ["true"]
                  : [],
                notificate_by_email: sessionInformation.notificate_by_email
                  ? ["true"]
                  : [],
                session_datetime: inputDateTimeLocal(
                  sessionInformation?.session_datetime
                ),
                timezones_to_show: sessionInformation?.timezones_to_show,
                group: groupId,
                will_be_recorded: sessionInformation.will_be_recorded
                  ? ["true"]
                  : [],
                complementary_material_downloadable: sessionInformation.complementary_material_downloadable
                  ? ["true"]
                  : [],
                recording_expiration_datetime:
                  sessionInformation?.recording_expiration_datetime
                    ? inputDateTimeLocal(
                      sessionInformation?.recording_expiration_datetime
                    )
                    : "",
                session_reminders_settings: sessionInformation?.session_reminders_settings.map(sett => ({ ...sett, exec_datetime: sett?.exec_datetime ? inputDateTimeLocal(sett?.exec_datetime) : null, enabled: sett?.enabled ? ['true'] : [] }))
              }}
              onSubmit={(values, actions) => {
                if (onSubmit) onSubmit({ values, actions });
              }}
              validateOnChange={false}
              validateOnBlur={formSubmmited}
              validationSchema={schema}
              enableReinitialize
            >
              {({ handleSubmit, ...rest }) => {
                return (
                  <form
                    className="theme-form"
                    onSubmit={(event) => {
                      setFormSubmmited(true);
                      handleSubmit(event);
                    }}
                    id="edit-session-form"
                  >
                    <SessionForm {...rest} isEdit={true} />
                  </form>
                );
              }}
            </Formik>
          </Grid.Col>
        </Grid.Row>

        <Grid.Row>
          <Grid.Col>
            <Link
              style={{ marginRight: "8px" }}
              options={{
                type: "outline",
                size: "lg",
                skin: "purple",
                native: true,
              }}
              href={`/dashboard/${groupInformation?.group_type}/${groupInformation?.id}/sessions`}
            >
              Cancelar
            </Link>

            <Submit
              isSubmmiting={sessionEditStates.loading}
              options={{
                type: "filled",
                size: "lg",
                skin: "purple",
              }}
              form="edit-session-form"
            >
              Guardar
            </Submit>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>

      <ModalWaitAMinuteBis />

      <Snackbar
        visible={sessionEditStates.success || !!sessionEditStates.error}
        options={{
          time: 2000,
          type: sessionEditStates.success ? "success" : "error",
        }}
      >
        {sessionEditStates.success
          ? "Encuentro editado."
          : "Error al editar el encuentro."}
      </Snackbar>
    </>
  );
};

const state = ({ groupStore, sessionStore, userStore }) => {
  const { data: sessionInformation, states: sessionStates } = sessionStore.one;
  const { states: sessionEditStates } = sessionStore.edit;
  const { data: groupInformation, states: groupStates } = groupStore.group;
  const { data: userInformation } = userStore.information;

  return {
    groupInformation,
    groupStates,
    sessionInformation,
    sessionStates,
    sessionEditStates,
    userInformation,
  };
};

export default connect(state)(Component);
